export interface LegalPersonBasicDataFields {
    govTaxId?: string;
    legalName?: string;
    fantasyName?: string;
    zipcode?: string;
    streetType?: string;
    street?: string;
    number?: string;
    district?: string;
    cityId?: string | number;
}

export interface GuarantorRetailFields {
    alias?: string;
    guaranteePercentage?: number | string;
}

const isBlankDigits = (value?: string) => !value?.replace(/\D/g, '');
const isBlankText = (value?: string) => !value?.trim();

const BASIC_DATA_RULES: Array<[string, (form: LegalPersonBasicDataFields) => boolean]> = [
    ['CNPJ', form => isBlankDigits(form.govTaxId)],
    ['Razão Social', form => isBlankText(form.legalName)],
    ['Nome Fantasia', form => isBlankText(form.fantasyName)],
    ['CEP', form => isBlankDigits(form.zipcode)],
    ['Tipo de logradouro', form => isBlankText(form.streetType)],
    ['Logradouro', form => isBlankText(form.street)],
    ['Número', form => isBlankText(form.number)],
    ['Bairro', form => isBlankText(form.district)],
    ['Cidade', form => !form.cityId],
];

export const missingBasicDataFields = (form: LegalPersonBasicDataFields): string[] =>
    BASIC_DATA_RULES.filter(([, isMissing]) => isMissing(form)).map(([label]) => label);

export const missingGuarantorRetailFields = (form: GuarantorRetailFields, profiles: string[]): string[] => {
    if (!profiles.includes('GUARANTOR-RETAIL')) return [];
    const missing: string[] = [];
    if (!form.alias) missing.push('Link único da parceira');
    if (!form.guaranteePercentage) missing.push('Aval');
    return missing;
};
